import React, { useState, useEffect } from 'react'
import { apiGet } from 'tennders-stracture/libs/api'

import { SelectType } from 'tennders-common/types/SelectType'
import GInput from './input'

type Props = Omit<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'onChange'> &{
  form? : Record<string, any>,
  name?: string,
  onChange?: (name: string, value: any) => void,
  placeholder ?: string,
  onlyInput ?: boolean
  withDiv ?: boolean,
  relative ?: boolean,
  onSet ?: (value: boolean) => void,
  value ?: boolean | string,
  error ?: string,
  errors ?: Record<string, any>,
  top ?: boolean | string | number,
  onTextSet ?: (value : string) => void,
  labelClass ?: string,
  children?: React.ReactNode | React.ReactNode[],
  eClass ?: string,
  label ?: string,
  inputClass ?: string,
  labelKey ?: string,
  url ?: string,
  defaultText ? :string,
  items ?: SelectType[]
}

const GAutocomplete = ({
  onChange,
  onSet,
  name,
  error,
  placeholder,
  label,
  labelKey,
  onlyInput,
  relative,
  labelClass,
  value,
  eClass,
  url,
  inputClass,
  top,
  items,
  errors,
  defaultText,
  onTextSet,
  ...rest
} : Props) => {
  const [suggestions, setSuggestions] = useState([])
  const [text, setText] = useState<string | boolean | undefined>(defaultText || '')
  const autoFixSuffix = Math.random() * 1000
  const onTextChanged = async (value) => {
    setText(value)
    if (onTextSet) {
      onTextSet(value)
    }
    if (items) {
      const filtered = [...items].filter((item) => item.label.includes(value) || item.label.includes(value))
      setSuggestions(filtered)
    } else if (value.length > 0) {
      const response = await apiGet(`${url}?query=${value}`)
      const op = response.map((o) => ({
        label: o.label,
        id: o.id
      }))
      setSuggestions(op)
    } else {
      setSuggestions([])
    }
  }

  const suggestionSelected = (item) => {
    setText(item.label.replace(/(<([^>]+)>)/gi, ''))
    setSuggestions([])
    if (onChange && name) {
      onChange(name, item)
    } else if (onSet) {
      onSet(item)
    }
  }

  const renderSuggestions = () => {
    if (suggestions.length === 0) {
      return null
    }
    return (
      <ul style={{
        position: relative ? 'relative' : 'absolute',
        top: typeof top === 'string' || typeof top === 'number' ? top : '70px',
        left: '0',
        padding: 12,
        border: '1px solid #ddd',
        boxShadow: '0 0 10px rgb(0 0 0 / 15%)',
        backgroundColor: 'white',
        zIndex: 99999
      }}
      >
        {suggestions?.map((item) => (
          <li
            style={{ cursor: 'pointer' }}
            key={item.locationId || item.id}
            onClick={() => suggestionSelected(item)}
          >
            <p>{item.label}</p>
          </li>
        ))}
      </ul>
    )
  }

  const renderInput = () => (
    <GInput
      id={`id${name}`}
      onlyInput={onlyInput}
      errors={errors}
      name={`${name}_${autoFixSuffix}`}
      error={errors && errors[name]}
      eClass={eClass || 'mr-8'}
      className={inputClass}
      val={(text || '') as string}
      onSet={onTextChanged}
      placeholder={placeholder}
      label={label}
      labelKey={labelKey}
      labelClass={labelClass}
      withDiv
    />
  )

  useEffect(() => {
    setText(value || '')
  }, [value])

  return (
    onlyInput ? (
      <>
        {renderInput()}
        {renderSuggestions()}
      </>
    )
      : (
        <div className="pos-rel mb-10" {...rest}>
          {renderInput()}
          {renderSuggestions()}
        </div>
      )
  )
}

export default GAutocomplete
